export default {
      id: "icon-print-usage",
      viewBox: "-3 -3 24 24",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#icon-print",
      toString: function () {
        return this.url;
      }
    }